import { useQuery } from "react-query";
import useNetworkHeaders from "../../../hooks/useNetworkHeaders";
import { postNotifyNotificationContentInfo, PostNotifyNotificationContentInfoBody } from "../../../queries/notify";

export function useNotifyNotificationInfo({ body }: { body: PostNotifyNotificationContentInfoBody }) {
  const networkHeaders = useNetworkHeaders();

  const {
    data: notificationInfo,
    isLoading: isNotificationInfoLoading,
    isFetching,
  } = useQuery(buildNotifyNotificationInfoQueryKey(body), postNotifyNotificationContentInfo(networkHeaders), {
    queryFnParamsFilter(args) {
      return [args[1]];
    },
    keepPreviousData: true,
  });

  return {
    notificationInfo,
    isNotificationInfoLoading,
    isNotificationInfoFetching: isFetching,
  };
}

export function buildNotifyNotificationInfoQueryKey(body: PostNotifyNotificationContentInfoBody) {
  return ["notifyNotificationInfo", body];
}
